import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterBenefitsService {

  private inputSearch= new BehaviorSubject<string>('');
  public inputText = this.inputSearch.asObservable();
  constructor() { }

  setText(newText:string){
    this.inputSearch.next(newText);
  }

}
